import { ref } from "vue";
import axiosInstance from "../config/axiosConfig.js";

class AgentService {
  constructor() {
    this.errors = ref({});
  }

  async verifyOtp() {
    try {
      const body = {
        phone_number: "255715000011",
        otp: "8261",
        website_agent: true,
      };
      const response = await axiosInstance.post(`/verify-otp`, body);
      if (response.data.success) {
        const token =
          response.data.data?.access_token ?? response.data.user?.access_token;
        localStorage.setItem("access_token", token);
      }
      return true;
    } catch (e) {
      if (e.response && e.response.status === 422) {
        this.errors.value = e.response.data.errors;
      } else {
        console.log("Error occurred while verifying agent OTP:", e);
      }
      return false;
    }
  }

  async getUserToken() {
    try {
      const body = { phone_number: "255715000011" };
      const response = await axiosInstance.post(`/get-user-token`, body);
      const data = response.data;
      if (!data.success || data.data?.invalid) {
        return await this.verifyOtp();
      } else {
        const token = data.data?.access_token ?? data.access_token;
        localStorage.setItem("access_token", token);
        return true;
      }
    } catch (e) {
      if (e.response?.status === 419) {
        return await this.verifyOtp();
      }
      return false;
    }
  }
}

export default AgentService;
